const autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};

const targetOffset = [0, 0];

export const placements = {
    left: {
        points: ['cr', 'cl'],
        overflow: autoAdjustOverflow,
        offset: [-4, 0],
        targetOffset
    },
    right: {
        points: ['cl', 'cr'],
        overflow: autoAdjustOverflow,
        offset: [4, 0],
        targetOffset
    },
    top: {
        points: ['bc', 'tc'],
        overflow: autoAdjustOverflow,
        offset: [0, -4],
        targetOffset
    },
    bottom: {
        points: ['tc', 'bc'],
        overflow: autoAdjustOverflow,
        offset: [0, 4],
        targetOffset
    },
    topLeft: {
        points: ['bl', 'tl'],
        overflow: autoAdjustOverflow,
        offset: [0, -4],
        targetOffset
    },
    leftTop: {
        points: ['br', 'tl'],
        overflow: autoAdjustOverflow,
        offset: [-4, 0],
        targetOffset
    },
    topRight: {
        points: ['br', 'tr'],
        overflow: autoAdjustOverflow,
        offset: [0, -4],
        targetOffset
    },
    rightTop: {
        points: ['bl', 'tr'],
        overflow: autoAdjustOverflow,
        offset: [4, 0],
        targetOffset
    },
    bottomRight: {
        points: ['tr', 'br'],
        overflow: autoAdjustOverflow,
        offset: [0, 4],
        targetOffset
    },
    rightBottom: {
        points: ['tl', 'br'],
        overflow: autoAdjustOverflow,
        offset: [4, 0],
        targetOffset
    },
    bottomLeft: {
        points: ['tl', 'bl'],
        overflow: autoAdjustOverflow,
        offset: [0, 4],
        targetOffset
    },
    leftBottom: {
        points: ['tr', 'bl'],
        overflow: autoAdjustOverflow,
        offset: [-4, 0],
        targetOffset
    }
};

export default placements;



// WEBPACK FOOTER //
// ./src/placements.js